import { useState } from "react";
import { useWalletLogContext } from "../../../../hooks/wallet-log-context";
import { WalletLogsFilterBox, WalletLogsFilterWrapper } from "./style";
import DropBox from "../../../../../../../components/drop-box";
import { getYearList } from "../../../../../../../utils/date";
import { WalletLogTab } from "../../../../hooks/use-wallet-tab";
import { useWalletContext } from "../../../../hooks/wallet-context";

const WalletLogsFilter = () => {
  const { year, month, setYear, setMonth } = useWalletLogContext();
  const { logTab } = useWalletContext();
  const [isYearOpen, setIsYearOpen] = useState(false);
  const [isMonthOpen, setIsMonthOpen] = useState(false);
  return (
    <WalletLogsFilterWrapper>
      <div className="title">내역</div>
      <WalletLogsFilterBox>
        <DropBox
          value={year}
          setValue={setYear}
          label={"년"}
          isOpen={isYearOpen}
          setIsOpen={setIsYearOpen}
          option={getYearList()}
        />
        {logTab !== WalletLogTab.SUBPRIZE && (
          <DropBox
            value={month}
            setValue={setMonth}
            label={"월"}
            isOpen={isMonthOpen}
            setIsOpen={setIsMonthOpen}
            option={[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]}
          />
        )}
      </WalletLogsFilterBox>
    </WalletLogsFilterWrapper>
  );
};

export default WalletLogsFilter;
